import { delay, put, takeLeading } from 'redux-saga/effects';
import { addItemReq, addItemRes } from '../actions/todo.action';
import { Action } from '../../types/redux.type';

function* addTodoSaga(action: Action<string>) {
	console.log(action);
	yield delay(2000);
	yield put(addItemRes(action.payload));
}
export function* todoSaga() {
	yield takeLeading(addItemReq, addTodoSaga);
}
